import { IOrder } from "records/order";
import { ILineItem } from "constants/order-types";

export interface IWorkingOrder extends Omit<IOrder, "line_items"> {
    line_items: ILineItem[];
    selected_shipping_locations: IShippingLocation[];
    __currencySymbol?: string;
}

interface IShippingLocation {
    _id: string;
    location: string; // address id
}

export enum AllocationType {
    Combined = "combined",
    ByLocation = "by location",
}
